import React from 'react'

import { Checkbox, HStack, Stack, Text } from '@chakra-ui/react'
import {
  RolePermission,
  WorksheetFieldRole,
} from 'src/legacy_modules/entities/small-item/entity'

type Props = {
  rolePermissions: RolePermission[]
  onChange: (rolePermissions: RolePermission[]) => void
  disabled: boolean
}

const allRoles: WorksheetFieldRole[] = [
  'MainDr',
  'MainCRC',
  'PartnerDr',
  'PartnerCRC',
]

const roleLabels: Record<WorksheetFieldRole, string> = {
  MainDr: 'Dr',
  MainCRC: 'CRC',
  PartnerDr: 'Dr',
  PartnerCRC: 'CRC',
}

type RoleGroup = {
  label: string
  roles: WorksheetFieldRole[]
}

const roleGroups: RoleGroup[] = [
  { label: '実施医療機関', roles: ['MainDr', 'MainCRC'] },
  { label: 'パートナー', roles: ['PartnerDr', 'PartnerCRC'] },
]

export const RolePermissionCheckbox: React.FC<Props> = props => {
  const { onChange, rolePermissions, disabled } = props

  const handleToggle = (role: WorksheetFieldRole) => {
    // すべてのロールが必ず存在するように、ないロールはReadOnlyで初期化
    const allPermissions = allRoles.map(r => {
      const existing = rolePermissions.find(rp => rp.role === r)
      return existing || { role: r, permissionType: 'ReadOnly' as const }
    })

    // 指定されたロールの権限を切り替え
    const newPermissions = allPermissions.map(rp =>
      rp.role === role
        ? {
            ...rp,
            permissionType: rp.permissionType === 'Edit' ? 'ReadOnly' : 'Edit',
          }
        : rp,
    ) as RolePermission[]

    // 全てのロールがReadOnly(=チェックなし)の場合は設定なしとみなし、空配列を返す
    const hasEditableRole = newPermissions.some(
      rp => rp.permissionType === 'Edit',
    )

    onChange(hasEditableRole ? newPermissions : [])
  }

  return (
    <Stack spacing="3">
      {roleGroups.map(group => (
        <HStack key={group.label} spacing="4" align="center">
          <Text minW="100px">{group.label}</Text>
          <HStack spacing="4">
            {group.roles.map(role => {
              const permission = rolePermissions.find(rp => rp.role === role)
              const isChecked = permission?.permissionType === 'Edit'

              return (
                <Checkbox
                  key={role}
                  isChecked={isChecked}
                  onChange={() => handleToggle(role)}
                  isDisabled={disabled}
                >
                  {roleLabels[role]}
                </Checkbox>
              )
            })}
          </HStack>
        </HStack>
      ))}
    </Stack>
  )
}
